import { IncCondForm } from '@/common/entities/incCond/IncCondForm';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';

export const IncCondDetail = () => {
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <IncCondForm /> },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="INC_COND" parentEntityId={entityObj.id} /> },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
